import React, { useEffect, useState } from 'react';
import { momentTimeFormater, timeOnly } from '../../../utils/dateHelper';
import classes from '../Home.module.css';
import { useLoader } from '../../../hooks/use-loader.hook';
import { BidMarketService } from '../../../services/BidMarketService';
import EChart from '../../../components/Echarts/Echarts';

const MarketInstanceCapacityCard = ({ market, groupId }) => {
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);
    const [group, setGroup] = useState({});

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        const params = {
            date: momentTimeFormater().format('YYYY-MM-DD'),
            market,
            instanceId: groupId,
        };
        BidMarketService.GetInstanceCapacity(
            params,
            () => startLoader(`${groupId}-capacity`),
            handleSuccess,
            handleError,
            () => stopLoader(`${groupId}-capacity`)
        );
    };

    const handleSuccess = ({ data }) => {
        const { capacityData, group } = data?.data;
        if (Array.isArray(capacityData)) {
            setData(capacityData);
        } else {
            setData([]);
        }
        if (group) setGroup(group);
        else {
            setGroup({});
        }
    };

    const handleError = (error) => {
        console.error(error);
    };

    return (
        <div className={classes.TopGraph} style={{ flexGrow: 2 }}>
            <EChart
                series={data}
                title={`${market} Sold Capacity (kW)`}
                subtext={`Date: ${momentTimeFormater().format('YYYY-MM-DD')}`}
                xFormatter={timeOnly}
                yFormatter={parseFloat}
                type="bar"
                rightSideElement={<strong>{group?.name || ''}</strong>}
                zoomOnMouseWheel={false}
                yTooltipSuffix={['kW', 'kW']}
            />
        </div>
    );
};

export default MarketInstanceCapacityCard;
